import React, { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import api from '../../service/api';

export default function DeleteExpense(props){

    let {
        visible,
        handleCancel,
        onDelete,
        code
    } = props;

    const toast = useRef(null);

    const onHide = () => {
        if(typeof handleCancel === 'function') handleCancel();
    }

    

    const handleDeleteExpense = () => {
        api().delete('/expense/' + code).then(response => {
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
            if(typeof onDelete === 'function') onDelete();
        });
    }

    const deleteExpenseDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteExpense} />
        </>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={visible} style={{ width: '450px' }} header="Atenção" modal footer={deleteExpenseDialogFooter} onHide={onHide}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {code && <span>Você tem certeza que deseja remover esta despesa?</span>}
                </div>
            </Dialog>
        </>
        
    );
}